import React from "react";
import styled from "styled-components";

const Tooltip = ({
                     name,
                     startDate,
                     endDate,
                     actionProgress,
                     isProject
                 }) => {
    return (
        <Container>
            <div><p><Span primary>Nom : </Span><Span> {name}</Span></p></div>
            <div><p><Span primary>Date de début : </Span> <Span>{startDate}</Span></p></div>
            <div><p><Span primary> Date de fin : </Span> <Span> {endDate}</Span></p></div>
            <div>
                <p>
                    <Span primary> Avancement {isProject ? "du projet" : "de l'action "} : </Span>
                    <Span>{actionProgress} %</Span>
                </p>
            </div>
        </Container>
    )
}


const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`

const Span = styled.span`
  font-size: 12px;
  font-weight: ${props => props.primary ? 800 : 500};
  color: var(--color-white);
`
export default Tooltip